// actions
export const LOAD_ADMIN_PERMISSIONS = 'LOAD_ADMIN_PERMISSIONS';
export const LOAD_TRANSLATIONS = 'LOAD_TRANSLATIONS';
export const LOAD_BODY_TRANSLATIONS = 'LOAD_BODY_TRANSLATIONS';
export const TOGGLE_UI = 'TOOGLE_UI';
export const SET_NPOS_FILTERS = 'SET_NPOS_FILTERS';
export const SET_NPOS_ERRORS = 'SET_NPOS_ERRORS';
export const SET_NPOS_VALUES = 'SET_NPOS_VALUES';
export const SET_PRINTER_JOB_INFO = 'SET_PRINTER_JOB_INFO';

// action creators
export const loadAdminPermissions = (isAdmin) => ({ isAdmin, type: LOAD_ADMIN_PERMISSIONS });
export const loadTranslations = (localeInfo) => ({ localeInfo, type: LOAD_TRANSLATIONS });
export const loadBodyTranslations = (translatedLocaleName) => ({ translatedLocaleName, type: LOAD_BODY_TRANSLATIONS });
export const toggleUi = (showNewUi) => ({ showNewUi, type: TOGGLE_UI });
export const setNposFilters = (filter) => ({ filter, type: SET_NPOS_FILTERS });
export const setNposErrors = (error, flush = false) => ({ error, flush, type: SET_NPOS_ERRORS });
export const setNposValue = (nposValues) => ({ nposValues, type: SET_NPOS_VALUES });
export const setPrintJobInfo = (printJobInfo) => ({ printJobInfo, type: SET_PRINTER_JOB_INFO });
